<template>
  <div>
    <ion-list-header>
      <ion-label>{{ $t("bookings.dates") }}</ion-label>
    </ion-list-header>
    <!-- <ion-segment v-model="currentSegment">
      <ion-segment-button value="start">
        <ion-label>
          {{ $t("bookings.checkInDate") }}
          <div class="date">{{ startDate ?? $t("bookings.selectDate") }}</div>
        </ion-label>
      </ion-segment-button>
      <ion-segment-button value="end" :disabled="internalDates.start === null">
        <ion-label>
          {{ $t("bookings.checkOutDate") }}
          <div class="date">{{ endDate ?? $t("bookings.selectDate") }}</div>
        </ion-label>
      </ion-segment-button>
    </ion-segment> -->
    <VDatePicker class="calendari-select" :locale="$i18n.locale === 'es-ca' ? 'ca' : $i18n.locale"
      v-model.range="internalDates" @update:modelValue="handleChange" :firstDayOfWeek="2" :min-date="new Date()"
      mode="date" :model-config="{
          type: 'string',
          mask: 'YYYY-MM-DD HH:mm',
        }" :masks="mask"></VDatePicker>
    <!-- <p>{{ internalDates }}</p> -->
    <div class="hours-container">
      <div class="hour-container">
        <div>{{ $t("bookings.pickupHour") }}</div>
        <VDatePicker v-model="internalDates.start" @update:modelValue="handleChange"
          :locale="$i18n.locale === 'es-ca' ? 'ca' : $i18n.locale" mode="time" :rules="rules" :masks="mask"
          :valid-hours="{ min: 9, max: 19 }" :minute-increment="15" is24hr />
        <select class="time-select" v-model="start" @change="handleChange">
          <option disabled>07:00 - 08:45 &mdash; {{ $t("bookings.selectableLater") }}</option>
          <option>09:00</option>
          <option>09:15</option>
          <option>09:30</option>
          <option>09:45</option>
          <option>10:00</option>
          <option>10:15</option>
          <option>10:30</option>
          <option>10:45</option>
          <option>11:00</option>
          <option>11:15</option>
          <option>11:30</option>
          <option>11:45</option>
          <option>12:00</option>
          <option>12:15</option>
          <option>12:30</option>
          <option>12:45</option>
          <option>13:00</option>
          <option>13:15</option>
          <option>13:30</option>
          <!-- <option>13:45</option> -->
          <!-- <option>14:00</option> -->
          <!-- <option>14:15</option> -->
          <!-- <option>14:30</option> -->
          <!-- <option>14:45</option> -->
          <option>15:00</option>
          <option>15:15</option>
          <option>15:30</option>
          <option>15:45</option>
          <option>16:00</option>
          <option>16:15</option>
          <option>16:30</option>
          <option>16:45</option>
          <option>17:00</option>
          <option>17:15</option>
          <option>17:30</option>
          <option>17:45</option>
          <option>18:00</option>
          <!-- <option>18:15</option> -->
          <!-- <option>18:30</option> -->
          <!-- <option>18:45</option> -->
          <!-- <option>19:00</option> -->
        </select>
      </div>
      <div class="hour-container">
        <div>{{ $t("bookings.dropHour") }}</div>
        <VDatePicker v-model="internalDates.end" @update:modelValue="handleChange"
          :locale="$i18n.locale === 'es-ca' ? 'ca' : $i18n.locale" mode="time" :rules="rules" :masks="mask"
          :valid-hours="{ min: 9, max: 19 }" :minute-increment="15" is24hr />
          <select class="time-select" v-model="end" @change="handleChange">
          <option>09:00</option>
          <option>09:15</option>
          <option>09:30</option>
          <option>09:45</option>
          <option>10:00</option>
          <option>10:15</option>
          <option>10:30</option>
          <option>10:45</option>
          <option>11:00</option>
          <option>11:15</option>
          <option>11:30</option>
          <option>11:45</option>
          <option>12:00</option>
          <option>12:15</option>
          <option>12:30</option>
          <option>12:45</option>
          <option>13:00</option>
          <option>13:15</option>
          <option>13:30</option>
          <!-- <option>13:45</option> -->
          <!-- <option>14:00</option> -->
          <!-- <option>14:15</option> -->
          <!-- <option>14:30</option> -->
          <!-- <option>14:45</option> -->
          <option>15:00</option>
          <option>15:15</option>
          <option>15:30</option>
          <option>15:45</option>
          <option>16:00</option>
          <option>16:15</option>
          <option>16:30</option>
          <option>16:45</option>
          <option>17:00</option>
          <option>17:15</option>
          <option>17:30</option>
          <option>17:45</option>
          <option>18:00</option>
          <option disabled>18:15 - 23:00 &mdash; {{ $t("bookings.selectableLater") }}</option>
          <!-- <option>18:15</option> -->
          <!-- <option>18:30</option> -->
          <!-- <option>18:45</option> -->
          <!-- <option>19:00</option> -->
          </select>
      </div>
    </div>

    <!-- <v-date-pick
      :locale="$i18n.locale === 'es-ca' ? 'ca' : $i18n.locale"
      v-show="currentSegment === 'start'"
      v-model="internalDates.start"
      :firstDayOfWeek="2"
      mode="dateTime"
      :min-date="new Date()"
      :valid-hours="{ min: 9, max: 19 }"
      :minute-increment="15"
      @change="handleChange"
      :model-config="{
        type: 'string',
        mask: 'YYYY-MM-DD HH:mm',
      }"
      is24hr
    ></v-date-pick>
    <ion-button
      class="next-btn"
      color="light"
      v-show="currentSegment === 'start' && internalDates.start !== null"
      @click="currentSegment = 'end'"
      >{{ $t("bookings.checkOutDate") }} <ion-icon :icon="arrowForward" />
    </ion-button>
    <v-date-pick
      :locale="$i18n.locale === 'es-ca' ? 'ca' : $i18n.locale"
      v-show="currentSegment === 'end'"
      v-model="internalDates.end"
      :firstDayOfWeek="2"
      mode="dateTime"
      ref="endCalendar"
      :attributes="dynamicAttr"
      :valid-hours="{ min: minHour, max: 19 }"
      :minute-increment="minuteIncrement"
      :min-date="minDate"
      :model-config="{
        type: 'string',
        mask: 'YYYY-MM-DD HH:mm',
      }"
      is24hr
    ></v-date-pick> -->
    <div class="error-msg" v-if="price && price.errorMsg">
      {{ $t("bookings." + price.errorMsg) }}
    </div>
  </div>
</template>

<script>
// import { DatePicker, Calendar } from "v-calendar";
import { defineComponent } from "vue";
import axios from "axios";
import { arrowForward } from "ionicons/icons";
import moment from "moment";

export default defineComponent({
  setup() {
    return {
      arrowForward,
    };
  },
  components: {
    // "v-date-pick": DatePicker,
  },
  props: {
    modelValue: {
      required: false,
      type: Object,
    },
    price: {
      required: false,
      type: Object,
    },
  },
  data: () => ({
    start: '09:00',
    end: '18:00',
    currentSegment: "start",
    mask: {
      modelValue: 'YYYY-MM-DD',
    },
    internalDates: {
      start: null,
      end: null,
    },
    firstTimeEnd: true,
    minHour: 19,
    minuteIncrement: 60,
    attributes: [
      {
        highlight: {
          start: { fillMode: "outline" },
          base: { fillMode: "light" },
          end: { fillMode: "outline" },
        },
        dates: { start: new Date(2022, 5, 14), end: new Date(2022, 5, 18) },
      },
    ],
    rules: {
      hours: {
        min: 8,
        max: 20
      },
      minutes: [0, 15, 30, 45]
    },
    firstTime: true
  }),
  watch: {
    // internalDates: {
    //   deep: true,
    //   handler() {
    //     // this.$refs.endCalendar.move(this.internalDates.start);

    //     // if (this.firstTimeEnd && this.internalDates.end !== null) {
    //     //   this.minHour = 9;
    //     //   this.minuteIncrement = 15;
    //     //   this.firstTimeEnd = false;
    //     // }

    //     // this.handleChange();
    //   },
    // },
    price: {
      deep: true,
      handler() {
        this.$emit("valid", 1, this.validForm);
      },
    },
  },
  beforeMount() {
    if (this.$route.query.start !== undefined) {
      this.internalDates.start = moment(this.$route.query.start).toDate();
      this.internalDates.end = moment(this.$route.query.end).toDate();
    }
  },
  methods: {
    handleChange() {
      // if (this.firstTime) {
      //   this.firstTime = false;
      //   this.internalDates = {
      //     start: moment(this.internalDates.start).hour(9).toDate(),
      //     end: moment(this.internalDates.end).hour(18).toDate()
      //   }
      // }
      this.$emit("update:modelValue", {
        start: moment(this.internalDates.start).format("YYYY-MM-DD") + " " + this.start,
        end: moment(this.internalDates.end).format("YYYY-MM-DD") + " " + this.end
      });
      this.$emit("valid", 1, this.validForm);
    },
  },
  computed: {
    startDate() {
      return this.internalDates.start !== null
        ? moment(this.internalDates.start).format("DD/MM/YYYY HH:mm")
        : null;
    },
    endDate() {
      return this.internalDates.end !== null
        ? moment(this.internalDates.end).format("DD/MM/YYYY HH:mm")
        : null;
    },
    validForm() {
      return (
        this.internalDates.start !== null &&
        this.internalDates.end !== null &&
        (this.price === null || this.price.errorMsg === null)
      );
    },
    minDate() {
      return this.internalDates.start
        ? moment(this.internalDates.start).format("YYYY-MM-DD") + " 19:00:00"
        : null;
    },
    dynamicAttr() {
      if (this.internalDates.start) {
        return [
          {
            highlight: {
              start: { fillMode: "outline" },
              base: { fillMode: "light" },
              end: { fillMode: "outline" },
            },
            dates: {
              start: this.internalDates.start,
              end: this.internalDates.end
                ? this.internalDates.end
                : this.internalDates.start,
            },
          },
        ];
      } else {
        return [];
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.hours-container {
  display: flex;
  margin: 0 20px;
}

.hour-container {
  border-radius: 6px;
  width: fit-content;
  flex: 1;
  padding: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .vc-container {
    width: auto !important;
  }
}

.v-picker {
  width: 100%;

  .v-date-picker-title__date>div {
    font-size: 22px;
  }

  .v-picker__body {
    width: 95% !important;
  }
}

.v-sheet.v-stepper {
  box-shadow: none !important;
  border: none !important;
  border-radius: 0 !important;
}

.vc-container.vc-blue,
.vc-monthly {
  border: none;
  width: 100%;
}

.vc-day-content {
  font-size: 18px;
}

.vc-day-box-center-center {
  margin: 10px 0;
}

ion-list {
  overflow: visible;
  contain: inherit;
}

ion-item {
  overflow: visible;
  z-index: 9;
}

.next-btn {
  float: right;
  position: relative;
  top: -50px;
  right: 17px;
}

.date {
  text-transform: initial;
  color: gray;
  font-weight: 400;
}

.segment-button-checked {
  background: #e2f5ff;
}

.error-msg {
  padding: 10px 16px;
  background: #ffdcdc;
  color: #981313;
  font-weight: 500;
  margin: 8px 10px;
}
.time-select {
  background: #f6fafc;
    color: #0e1729;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    font-size: 17px;
    font-weight: 500;
    letter-spacing: 2px;
    padding: 5px 10px;
    max-width: 110px;
}

</style>
